export const TEMPLATE_HISTORY_VIEW = "TEMPLATE_HISTORY_VIEW";
export const TEMPLATE_HISTORY_CHANGES_VIEW = "TEMPLATE_HISTORY_CHANGES_VIEW";
